import { hotComments } from "@/mocks/gossip";
import SectionHeading from "./SectionHeading";

const avatarBg = [
  "bg-primary-500 text-background-50",
  "bg-accent-500 text-background-50",
  "bg-secondary-400 text-background-50",
  "bg-primary-400 text-background-50",
  "bg-accent-600 text-background-50",
];

export default function DiscussionSection() {
  return (
    <section id="luntan" className="container-x py-10 md:py-14">
      <SectionHeading
        kicker="社区讨论 · 大家怎么想"
        title="讨论区热评"
        desc="吃瓜不只在楼里，前因后果理清之后，评论区才是这口瓜最热闹的地方。看看大家怎么站队、怎么补充时间线。"
      />

      <div className="grid grid-cols-1 gap-5 lg:grid-cols-5 md:gap-6">
        {/* compose mock */}
        <div className="lg:col-span-2">
          <div className="flex h-full flex-col rounded-2xl border border-background-200 bg-background-100 p-5">
            <div className="flex items-center gap-3">
              <span className="grid h-11 w-11 place-items-center rounded-full bg-accent-500 text-sm font-bold text-background-50">
                瓜
              </span>
              <div>
                <p className="font-heading text-sm font-bold text-foreground-950">我也想说两句</p>
                <p className="text-xs text-foreground-500">补充线索 / 求时间线 / 理性讨论</p>
              </div>
            </div>
            <textarea
              aria-label="讨论输入框"
              placeholder="补充一条线索，或说说你对这口瓜的看法……（本页为演示，不会真实发布）"
              maxLength={500}
              className="mt-4 min-h-[140px] flex-1 resize-none rounded-xl border border-background-300 bg-background-50 px-4 py-3 text-sm text-foreground-800 outline-none transition-colors placeholder:text-foreground-400 focus:border-primary-300"
            />
            <div className="mt-3 flex items-center justify-between">
              <div className="flex items-center gap-1 text-xs text-foreground-400">
                <i className="ri-image-add-line text-base"></i>
                <i className="ri-link text-base"></i>
                <span className="ml-1 hidden sm:inline">最多 500 字</span>
              </div>
              <button
                type="button"
                className="rounded-md bg-primary-500 px-4 py-2 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600 whitespace-nowrap"
              >
                发布讨论
              </button>
            </div>
          </div>
        </div>

        {/* comments */}
        <div className="flex flex-col gap-3 lg:col-span-3">
          {hotComments.map((c, i) => (
            <div
              key={c.user}
              className="rounded-xl border border-background-200 bg-background-50 p-4"
            >
              <div className="flex items-center gap-3">
                <span
                  className={`grid h-9 w-9 shrink-0 place-items-center rounded-full text-xs font-bold ${avatarBg[i % avatarBg.length]}`}
                >
                  {c.user.slice(0, 1)}
                </span>
                <div className="min-w-0 flex-1">
                  <p className="flex flex-wrap items-center gap-2">
                    <span className="font-heading text-sm font-bold text-foreground-950">{c.user}</span>
                    <span className="rounded-md bg-secondary-100 px-2 py-0.5 text-[11px] font-medium text-secondary-700 whitespace-nowrap">
                      {c.role}
                    </span>
                  </p>
                  <p className="text-xs text-foreground-400">第 {100 + i * 7} 楼 · 刚刚</p>
                </div>
                <span className="inline-flex items-center gap-1 text-xs font-semibold text-primary-600 whitespace-nowrap">
                  <i className="ri-thumb-up-fill"></i>
                  {c.likes}
                </span>
              </div>
              <p className="mt-2.5 text-sm leading-relaxed text-foreground-700">{c.text}</p>
              <div className="mt-2.5 flex items-center gap-4 text-xs text-foreground-500">
                <span className="inline-flex items-center gap-1 hover:text-primary-600">
                  <i className="ri-reply-line"></i>回复 {c.replies}
                </span>
                <span className="inline-flex items-center gap-1 hover:text-primary-600">
                  <i className="ri-thumb-up-line"></i>赞
                </span>
                <span className="inline-flex items-center gap-1 hover:text-primary-600">
                  <i className="ri-share-line"></i>分享
                </span>
              </div>
            </div>
          ))}
          <a
            href="#luntan"
            className="mx-auto mt-1 inline-flex items-center gap-1.5 text-sm font-semibold text-primary-600 hover:text-primary-700 whitespace-nowrap"
          >
            查看更多热评<i className="ri-arrow-down-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}